import React, { useEffect } from 'react';
import { useAppState } from '../../state';

import DialecticaLogo from '../../icons/DialecticaLogo';
import VideoLogo from '../IntroContainer/VideoLogo';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const Background = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#191b1d',
  height: '100%',
});

const Container = styled('div')({
  position: 'relative',
  flex: '1',
});

const InnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '888px',
  height: '379px',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px 0px rgba(40, 42, 43, 0.3)',
  overflow: 'hidden',
  position: 'relative',
  margin: 'auto',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
    height: 'auto',
    width: 'calc(100% - 40px)',
    margin: 'auto',
    maxWidth: '400px',
  },
}));

const SwooshContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#10416D',
  width: '296px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100px',
    backgroundPositionY: '140px',
  },
}));

const LogoContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '210px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    alignItems: 'center',
    width: '90%',
    textAlign: 'initial',
    '& svg': {
      height: '64px',
    },
  },
}));

const Content = styled('div')(({ theme }) => ({
  background: 'white',
  width: '100%',
  padding: '4em',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    padding: '2em',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: 'white',
  margin: '1em 0 0',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    fontSize: '1.1rem',
  },
}));

const StyledDialecticaLogo = styled(DialecticaLogo)({
  top: '10px',
  left: '12px',
  position: 'absolute',
  height: '40px',
});

const BodyText = styled(Typography)({
  marginBottom: '1em',
  whiteSpace: 'pre-line',
});

const GutterBottomTypography = styled(Typography)({
  marginBottom: '1em',
});

export default function TimeoutPage() {
  const { signOut, meeting } = useAppState();

  useEffect(() => {
    window?.gtag('event', 'Redirect To Timeout', { 'meetingId': meeting?.meeting_id || '' });
    signOut?.();
  }, []);

  return (
    <Background>
      <StyledDialecticaLogo />
      <Container>
        <InnerContainer>
          <SwooshContainer>
            <LogoContainer>
              <VideoLogo />
              <Title variant="h6"> Meeting Timeout </Title>
            </LogoContainer>
          </SwooshContainer>
          <Content>
            <GutterBottomTypography variant="h5">
              Hi!
            </GutterBottomTypography>
            <BodyText variant="body1">
              Sorry about this, you have landed on this page due to a timeout or network connectivity issue.
            </BodyText>
            <BodyText variant="body1">
              Please click on the meeting link in your invite to rejoin, or dial in with number provided.
            </BodyText>
          </Content>
        </InnerContainer>
      </Container>
    </Background>
  );
}
